import { z } from 'zod';

export const filestackUploadPayloadSchema = z.object({
  container: z.string(),
  filename: z.string(),
  handle: z.string(),
  key: z.string(),
  mimetype: z.string(),
  size: z.number(),
  url: z.string(),
});

export type FilestackUploadPayload = z.infer<typeof filestackUploadPayloadSchema>;

export function parseFilestackUploadPayload(raw: unknown) {
  const parsed = filestackUploadPayloadSchema.safeParse(raw);
  if (!parsed.success) throw new Error('Uploaded file returned unexpected data from storage.');

  return parsed.data;
}

export function parseFilestackUploadPayloads(raw: unknown, expectedCount: number) {
  const parsed = z.array(filestackUploadPayloadSchema).safeParse(raw);
  if (!parsed.success) throw new Error('Uploaded files returned unexpected data from storage.');
  if (parsed.data.length !== expectedCount) {
    throw new Error('Uploaded files returned unexpected data from storage.');
  }

  return parsed.data;
}
